Controller = App.loadClass 'core::Angular/Controller'

class exports.QuotesController extends Controller
    constructor: (@scope, @transitions, @data, @modal) ->
        @scope.title = 'Quotes'
        @scope.fullpage = true
        @scope.absolute_errors = true

        # Instance data
        @scope.quotes = []
        @scope.displayedCollection = []

        @scope.launchContextDialog = @launchContextDialog
        @scope.launchAddQuoteDialog = @launchAddQuoteDialog

        @loadScopeData @data.getQuotes(), 'quotes'

    launchContextDialog: (quote) =>
        modal = @modal.open
            windowClass: 'modal-width'
            templateUrl: 'backend/admin/quotes/load-layout-context-dialog'
            controller: 'Funsies.Controllers.ContextController'
            resolve:
                quote: => quote

        modal.result.then () =>
            @loadScopeData @data.getQuotes(), 'quotes'

    launchAddQuoteDialog: () =>
        modal = @modal.open
            windowClass: 'medium_dialog'
            templateUrl: 'backend/admin/quotes/load-layout-add-quote-dialog'
            controller: 'Funsies.Controllers.AddQuoteController'

        modal.result.then () =>
            @loadScopeData @data.getQuotes(), 'quotes'
